import { IdentityProductGraphics, IdentityQrFrame, identityCssVariables, identityProductLanguage } from "./designSystem";

function PaddockIdentityCard({ settings, headerLogo, qr, vehicleTitle }) {
  const language = identityProductLanguage.card;
  return (
    <div className={`paddock-identity-card base-${settings.baseTheme} finish-${settings.finish}`} style={identityCssVariables(settings.accentColor, settings.baseTheme)}>
      <IdentityProductGraphics product="card" />

      <section className={`card-brand-zone ${settings.showCarName && vehicleTitle ? "has-name" : ""}`} aria-label="MyBuildID branding">
        <img src={headerLogo} alt="MyBuildID" />
        {settings.showCarName && vehicleTitle && <span className="card-vehicle-name" title={vehicleTitle} aria-label={vehicleTitle}>{vehicleTitle}</span>}
        <div className="card-micro-bars" aria-hidden="true"><i /><i /><i /><i /><i /></div>
      </section>

      <IdentityQrFrame variant={language.qrFrame} className="card-qr-frame">{qr}</IdentityQrFrame>

      <section className="card-cta-zone">
        <span className="card-cta-divider" aria-hidden="true" />
        <strong>Scan to view<br />my build</strong>
        <span>MYBUILDID.COM</span>
        <small>VEHICLE PROFILE ACCESS</small>
      </section>
    </div>
  );
}

export default PaddockIdentityCard;
